import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Most of the technical-changes work should be for ootb or planning tech changes
 *
 * @returns `true` when one of the technical changes flags are on
 */
export const isPlanWorkItemTechChangesEnabled = (): boolean =>
	fg('jira_ai_task_level_planning_ootb_agent') ||
	fg('jira-ai-agentic-planning-technical-changes') ||
	fg('jira-ai-repo-selection-technical-extraction');

/**
 * The collaborative session experience is explicitly NOT wanted for the OOTB agent.
 *
 * @returns `true` when technical-changes is enabled and the OOTB agent is disabled.
 */
export const isCollaborativeSessionEnabled = (): boolean => {
	const isTechChanges = fg('jira-ai-agentic-planning-technical-changes');
	const isOotbAgent = fg('jira_ai_task_level_planning_ootb_agent');
	const isRepoSelection = fg('jira-ai-repo-selection-technical-extraction');
	return (isTechChanges && !isOotbAgent) || isRepoSelection;
};
